import { defaultViewForPermissions, syncUrlForView } from '../routes';

const InitLogin = () => {

    const viewInit = (permission, setActiveTab) => {
        const view = defaultViewForPermissions(permission || []);
        setActiveTab(view);
        syncUrlForView(view, true);
      }
    return viewInit
};

export default InitLogin;
